import React, { useEffect, useState } from 'react';
import API from '../../Services/api';
import RecyclingRequests from './RecyclingRequests';

const StaffDashboard = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await API.get('/collection-staff/requests');
        setRequests(response.data);
      } catch (error) {
        console.error('Failed to fetch requests', error);
      } finally {
        setLoading(false);
      }
    };
    fetchRequests();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('staff-token');
    window.location.href = '/staff-login';
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFB]">
      {/* Header */}
      <header className="bg-[#F8FAFB] border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 z-50 shadow-sm">
        <a href="/">
          <img src="/images/header_logo.png" alt="e-save Logo" className="h-10" />
        </a>
        <div className="flex items-center space-x-3">
          <span className="hidden sm:inline text-sm text-[#6E7C87]">Staff Dashboard</span>
          <div className="w-px h-5 bg-gray-300 hidden sm:block" />
          <button
            onClick={() => setShowLogoutModal(true)}
            className="flex items-center space-x-2 bg-[#FF6666] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#cc3333] transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 001 1h7a1 1 0 000-2H4V5h6a1 1 0 000-2H3zm11.293 4.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L15.586 11H9a1 1 0 010-2h6.586l-1.293-1.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </header>

      {/* Logout confirmation modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm mx-4">
            <h3 className="text-xl font-bold text-[#172A3A] mb-2">Confirm logout</h3>
            <p className="text-[#6E7C87] text-sm mb-6">Are you sure you want to sign out of the staff dashboard?</p>
            <div className="flex space-x-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="flex-1 border border-gray-300 text-[#414042] py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 bg-[#FF6666] text-white py-2 rounded-lg hover:bg-[#cc3333] transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main content */}
      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Stats bar */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex items-center space-x-4">
            <div className="w-10 h-10 rounded-full bg-[#EEFAF7] flex items-center justify-center flex-shrink-0">
              <img src="/images/recycle-sign.png" alt="Requests" className="w-6 h-6" />
            </div>
            <div>
              <p className="text-2xl font-bold text-[#172A3A]">{requests.length}</p>
              <p className="text-xs text-[#6E7C87]">Total Requests</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex items-center space-x-4">
            <div className="w-10 h-10 rounded-full bg-[#FFF8E7] flex items-center justify-center flex-shrink-0">
              <div className="w-3 h-3 rounded-full bg-[#FFC107]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-[#172A3A]">
                {requests.filter(r => r.status === 'Pending').length}
              </p>
              <p className="text-xs text-[#6E7C87]">Pending</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex items-center space-x-4 col-span-2 sm:col-span-1">
            <div className="w-10 h-10 rounded-full bg-[#EEFAF7] flex items-center justify-center flex-shrink-0">
              <div className="w-3 h-3 rounded-full bg-[#38D9B9]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-[#172A3A]">
                {requests.filter(r => r.status === 'Completed').length}
              </p>
              <p className="text-xs text-[#6E7C87]">Completed</p>
            </div>
          </div>
        </div>

        {/* Requests section */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <h2 className="text-lg font-semibold text-[#172A3A] mb-4">Recycling Requests</h2>
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-[#29752B]" />
            </div>
          ) : (
            <RecyclingRequests requests={requests} />
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-4 text-center text-xs text-[#6E7C87]">
        © {new Date().getFullYear()} e-save — Staff Portal
      </footer>
    </div>
  );
};

export default StaffDashboard;
